import DemoAddressesTableItemDetails from './DemoAddressesTableItemDetails'

export default DemoAddressesTableItemDetails
